export const lineContainsOnlyNode = (line, nodeRef) => line.text.trim().length === nodeRef.to - nodeRef.from;
